import { Tab } from "@headlessui/react";
import CourseCardV2List from "./CourseCardV2List";
import { useRouter } from "next/router";
import { courseNavigationData } from "@/config/navigation";
import { useMemo } from "react";

const CourseListFilter = (props: { category: any, data: any }) => {
  const { category, data } = props;
  const router = useRouter();
  let courseNavigation: any = courseNavigationData.find(x => x.url == router.asPath.split("&")[0]);
  if (!courseNavigation) {
    for (let i = 0; i < courseNavigationData.length; i++) {
      if (!courseNavigationData[i].content) continue;
      // @ts-ignore
      courseNavigation = courseNavigationData[i].content.find(y => y.url == router.asPath.split("&")[0]);
      if (courseNavigation) break;
    }
  }

  const filters = courseNavigation?.content || [];

  const groupedData = useMemo(() => {
    return {
      "All": { name: "All", url: courseNavigation?.url, next: true },
      ...filters.reduce((prev: any, curr: any) => {
        prev[curr.name] = curr;
        return prev;
      }, {} as { [key: string]: { name: string, url: string, next?: boolean } })
    };
  }, [filters, courseNavigation?.url]);

  const handleTabClick = (item: any) => {
    if (!item.url) return;
    router.push(item.url)
  }

  const classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(" ");
  }

  const studentClass = router.query.Class as string;

  const tabItem = studentClass == "13" ? "12+" : studentClass;
  const tabItemIndex = useMemo(() => {
    return Object.keys(groupedData).findIndex(item => item.includes(tabItem?.trim())) == -1 ? 0 : Object.keys(groupedData).findIndex(item => item.includes(tabItem?.trim()));
  }, [groupedData, tabItem]);

  if (!Object.keys(groupedData).length) {
    return <CourseCardV2List category={category} items={data} />
  }
  return (
    <div className="flex flex-col">
      <div className="w-full">
        <Tab.Group defaultIndex={tabItemIndex}>
          <Tab.List className="max-w-max overflow-x-scroll scrollbar flex gap-2 p-2">
            {Object.keys(groupedData).map((category, index) => (
              <Tab
                key={category}
                className={({ selected }) =>
                  classNames(
                    "shrink-0 mrounded-lg px-4 sm:px-8 p-2.5 text-sm font-medium leading-5 hover:text-accent",
                    "focus-visible:outline-none",
                    (tabItemIndex === index)
                      ? "border-b-2 border-accent text-accent hover:border-accent"
                      : ""
                  )
                }
                onClick={() => handleTabClick(groupedData[category])}
              >
                {category}
              </Tab>
            ))}
          </Tab.List>
        </Tab.Group>
      </div>
      <CourseCardV2List category={category} items={data.items.filter((item: any) => item.assortment_id)} />
    </div>
  )
}

export default CourseListFilter